import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function StringsHauled({ stringsHauled, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "stringsHauled")}
      </h2>
      <TextField
        name="stringsHauled"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        size="small"
        type="number"
        value={stringsHauled}
        onChange={handleChange}
      />
      <HelpText
        helpText={getFieldLabel("effort", "stringsHauled", "helptext")}
      />
    </Box>
  );
}

export default StringsHauled;
